module.exports = __webpack_public_path__ + "basic.svg?ed0d0bb1fd4114b0a7422f94145f3c51";


//////////////////
// WEBPACK FOOTER
// ./src/assets/patterns/basic.svg
// module id = 95
// module chunks = 0